import React, { memo, FC } from 'react'
import moment from 'moment'
import DoubleArrowLeft from 'assets/svgs/double-arrow-left.svg'
import { useDelayedCallback } from 'hooks/useDelayedCallback'
import styles from './style.module.css'
import { BOOKING_STATUS } from 'constants/Booking'
import { BookingWorkRecordEntryFinishStatus } from '../../type'

type Props = {
  status: BookingWorkRecordEntryFinishStatus
  hyphenatedBookingNumber: string
  finishedAt: string | null
  onBackButtonClick: () => void
}

const STATUS_MESSAGES: Record<BookingWorkRecordEntryFinishStatus, string> = {
  [BOOKING_STATUS.Working]: 'ステータスを「作業中」に変更しました。作業を開始してください。',
  [BOOKING_STATUS.Finish]: 'ステータスを「完了」に変更しました。退場をしてください。',
}

const BookingWorkRecordEntryFinish: FC<Props> = ({
  status,
  hyphenatedBookingNumber,
  finishedAt,
  onBackButtonClick,
}) => {
  useDelayedCallback(onBackButtonClick, 5000)

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.title}>ステータス変更完了</div>
        <div className={styles.message}>{STATUS_MESSAGES[status]}</div>

        <div className={styles.infoRow}>
          <span className={styles.infoLabel}>受付番号</span>
          <span>{hyphenatedBookingNumber}</span>
        </div>
        {status === BOOKING_STATUS.Finish && finishedAt && (
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>退場日時</span>
            <span>{moment(finishedAt).format('YYYY/MM/DD HH:mm')}</span>
          </div>
        )}
      </div>

      <div className={styles.backButtonArea}>
        <span
          role="button"
          tabIndex={0}
          className={styles.backButton}
          onClick={onBackButtonClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onBackButtonClick()
          }}
        >
          <img src={DoubleArrowLeft} alt="double arrow left" className={styles.backButtonIcon} />
          はじめにもどる
        </span>
      </div>
    </div>
  )
}

export default memo(BookingWorkRecordEntryFinish)
